import { useDispatch, useSelector } from "react-redux";
import { toggleFraseSeleccionAplicacionActiveThunk } from "../../store/frasesSeleccionAplicacion/frasesSeleccionAplicacion.thunks";
import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import { closeConfirmToggle } from "../../store/frasesSeleccionAplicacion/frasesSeleccionAplicacion.reducer";

const ConfirmToggleSeleccionAplicacionModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, toggleFraseId, toggling } = useSelector(
    (state) => state.frasesSeleccionAplicacion,
  );

  const frase = useSelector((state) =>
    state.frasesSeleccionAplicacion.list.find((f) => f.id === toggleFraseId),
  );

  const handleConfirm = () => {
    dispatch(toggleFraseSeleccionAplicacionActiveThunk(toggleFraseId));
  };

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {toggling ? (
        <Loader center text="Actualizando frase..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{frase?.is_active ? "desactivar" : "activar"}</strong> la
            frase <strong>"{frase?.frase}"</strong>?
          </p>
          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeConfirmToggle())}
            >
              Cancelar
            </button>
            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleSeleccionAplicacionModal;
